﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import tpl_customDepartmentImportList from './tpl/customDepartmentImportList.html';
import View_CustomDepartmentImportListItem from './customDepartmentImportListItem';

export default Marionette.CollectionView.extend({
    childViewContainer: '#customDepartmentImportList',
    childView: View_CustomDepartmentImportListItem,
    getTemplate: function () {
        return tpl_customDepartmentImportList();
    },
    initialize: function () {
        this.app = this.options.app;
    },
    buildChildView: function(child, ChildViewClass, childViewOptions){
        var options = _.extend({model: child}, childViewOptions);
        options.app = this.app;
        var view = new ChildViewClass(options);
        return view;
    }
});